import { useEffect } from 'react';

import { mustGetAccountPlan } from '@/data/account/selectors';
import { getAuthAccount, getAuthUser } from '@/shared/auth/selectors';
import Identify from '@/shared/vendor/identify';
import { useWiwSelector } from '@/store';

type ZendeskMessengerInitializerProps = {
  cutoverComplete: boolean;
};

export default function ZendeskMessengerInitializer({ cutoverComplete }: ZendeskMessengerInitializerProps) {
  const user = useWiwSelector(getAuthUser);
  const account = useWiwSelector(getAuthAccount);
  const plan = useWiwSelector(mustGetAccountPlan);

  useEffect(() => {
    if (cutoverComplete) {
      window.zE?.('messenger', 'logoutUser');
      window.zE?.('messenger', 'hide');
      return;
    }

    Identify.identifyZendesk(user, account, plan);
  }, [account, cutoverComplete, plan, user]);

  return null;
}
